var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "slider-component-wrapper"
  }, [_c('div', {
    staticClass: "light-text small pop-500 description-slider"
  }, [_vm._v(" " + _vm._s(_vm.description) + " "), _c('span', {
    staticClass: "pop-900"
  }, [_vm._v(_vm._s(_vm.mainDesc))])]), _c('div', {
    "class": [_vm.percentageShow ? 'd-flex justify-content-between flex-row align-items-center' : '']
  }, [_c('div', [_vm.sliderOnly ? _c('span', {
    staticClass: "pop-800",
    on: {
      "click": function click($event) {
        return _vm.$emit('value-click');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.value)) + " ")]) : _c('chip-input', {
    attrs: {
      "id": _vm.idSelected,
      "type": 'number',
      "factor": 8,
      "min": _vm.min,
      "max": _vm.max,
      "default-value": _vm.defaultValue,
      "value-given": parseInt(_vm.value),
      "value-correction": _vm.correctChipInput
    },
    on: {
      "value-corrected": function valueCorrected($event) {
        _vm.correctChipInput = null;
      },
      "change-event": function changeEvent($event) {
        return _vm.emitValue($event);
      }
    }
  }), _c('span', {
    staticClass: "pop-800 unit"
  }, [_vm._v(" " + _vm._s(_vm.unit))])], 1), _vm.percentageShow ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "bold big mr-2"
  }, [_vm._v(" " + _vm._s(_vm.percentage) + " %")]), _c('div', {
    staticClass: "div-block-109 noselect"
  }, [_c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('index-value-up-click', _vm.percentage);
      }
    }
  }), _c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f29_icons8-expand-arrow.svg",
      "loading": "lazy"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('index-value-down-click', _vm.percentage);
      }
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "slide-container",
    "class": {
      'opacity-30': _vm.mainDesc === 'refinancovanie'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.value,
      expression: "value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "slider-input",
    attrs: {
      "type": "range",
      "id": "slider",
      "min": _vm.min,
      "max": _vm.max,
      "disabled": _vm.disabledSlider
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function change($event) {
        return _vm.emitValue(null);
      },
      "__r": function __r($event) {
        _vm.value = _vm._n($event.target.value);
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "noselect slider-progress-wrapper"
  }, [_c('div', {
    staticClass: "noselect selected-part",
    attrs: {
      "id": _vm.idSelected
    }
  }), _c('div', {
    staticClass: "noselect nonselected-part",
    attrs: {
      "id": _vm.idNotSelected
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }